// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"88":"hy","736":"vendor"}[chunkId] + "." + {"88":"4d58207067f001396bb0","736":"ed4e167501b012265e18"}[chunkId] + ".css";
};